import { useAsyncOperation } from "@core/hooks/use-async-operation";
import { useI18n } from "@core/i18n/i18n";
import { legalContentManager } from "@core/service-container";
import styled from "@emotion/styled";
import { NetworkError } from "@ui/components/common/error";
import { LoadingContainer } from "@ui/components/common/loading-container";
import { RoutesPath } from "@ui/navigation/routes";
import { DocumentViewer } from "@ui/pages/legal-content/components/document-viewer";
import { stack } from "@ui/style/layout";
import { useObservable } from "micro-observables";
import React, { useCallback, useEffect } from "react";

export const PrivacyNoticePage = (): JSX.Element => {
	const { format, locale } = useI18n();
	const fetchPrivacyNotice = useCallback(() => legalContentManager.retrievePrivacyNotice(locale), [locale]);
	const [operation, isLoading, isError] = useAsyncOperation(fetchPrivacyNotice, {});
	const privacyNotice = useObservable(legalContentManager.privacyNotice);

	useEffect(() => {
		operation();
	}, [operation]);

	let content: JSX.Element | null;
	if (privacyNotice) {
		content = (
			<DocumentViewer
				title={format("legalContent.privacyNotice.title")}
				content={privacyNotice.content}
				headerLink={{ label: format("legalContent.privacyNotice.switchLabel"), to: RoutesPath.TermsOfUse }}
			/>
		);
	} else if (isLoading) {
		content = <LoadingContainer />;
	} else {
		content = isError ? <NetworkError onRefresh={operation} /> : null;
	}

	return (
		<Container>{content}</Container>
	);
};

const Container = styled.div`
	${stack(undefined, "center", "stretch")};
	flex-grow: 1;
`;
